import { render, staticRenderFns } from "./work-area.vue?vue&type=template&id=59b287bd&scoped=true"
import script from "./work-area.vue?vue&type=script&lang=js"
export * from "./work-area.vue?vue&type=script&lang=js"
import style0 from "./work-area.vue?vue&type=style&index=0&id=59b287bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b287bd",
  null
  
)

export default component.exports